import React, { type PropsWithoutRef } from 'react'
import { type GatsbyLinkProps, Link as GatsbyLink } from 'gatsby'

import { isAgentApp } from '@/utils'
import { URLS } from '@/constants'

const MPLink = <TState,>({
  children,
  ...props
}: PropsWithoutRef<GatsbyLinkProps<TState>>) => {
  if (isAgentApp && props.to === '/') {
    props.to = URLS.APPS.LINK
  }

  return <GatsbyLink<TState> {...props}>{children}</GatsbyLink>
}

export default MPLink
